// @flow
/**
 * @module Reducers/BankStatements
 * @desc Bank Statements Reducer
 */

import { handleActions } from 'redux-actions';
import { BankStatementsConstants } from 'constants/bankStatementsConstants';
import { requestFail, requestPending, requestSuccess } from 'components/Fetch';
import { UserRole } from 'utils/bankStatements';

const initialState = {
  transactions: {
    isSaving: false,
  },
  isLoading: false,
  statements: [],
  dataVersion: 0,
  settings: {
    confidenceThreshold: null,
    userRole: UserRole.User,
  },
  error: null,
};

export default handleActions({
  [BankStatementsConstants.SET_IS_SAVING]: (state, action) => ({
    ...state,
    transactions: {
      ...state.transactions,
      isSaving: action.payload,
    },
  }),
  [requestPending(BankStatementsConstants.GET_STATEMENTS)]: state => ({
    ...state,
    isLoading: true,
  }),
  [requestSuccess(BankStatementsConstants.GET_STATEMENTS)]: (state, action) => ({
    ...state,
    statements: action.payload,
    isLoading: false,
  }),
  [requestFail(BankStatementsConstants.GET_STATEMENTS)]: (state, action) => ({
    ...state,
    error: action.payload,
    isLoading: false,
  }),

  [requestPending(BankStatementsConstants.GET_CONFIDENCE_THRESHOLD)]: state => ({
    ...state,
    isLoading: true,
  }),
  [requestSuccess(BankStatementsConstants.GET_CONFIDENCE_THRESHOLD)]: (state, action) => ({
    ...state,
    settings: {
      ...state.settings,
      confidenceThreshold: action.payload.confidenceThreshold,
    },
    isLoading: false,
  }),
  [requestFail(BankStatementsConstants.GET_CONFIDENCE_THRESHOLD)]: (state, action) => ({
    ...state,
    error: action.payload,
    isLoading: false,
  }),

  [BankStatementsConstants.SET_DATA_VERSION]: (state, action) => ({
    ...state,
    dataVersion: action.payload,
  }),
}, initialState);
